import { X } from "lucide-react";
import type { LabelColor } from "@kandoo/shared";
import { LABEL_COLOR_KEYS, labelColor } from "../util/labelColors";

interface ColorSwatchesProps {
  value: LabelColor | null;
  onChange: (color: LabelColor | null) => void;
  /** Show a "none" option (rendered as a crossed-out swatch). */
  allowNone?: boolean;
}

/** A row of color swatches for picking a palette color (optionally "none"). */
export function ColorSwatches({ value, onChange, allowNone }: ColorSwatchesProps) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {LABEL_COLOR_KEYS.map((key) => (
        <button
          key={key}
          type="button"
          title={labelColor(key).label}
          onClick={() => onChange(key)}
          className={`h-7 w-7 rounded ${labelColor(key).swatch} ${
            value === key ? "ring-2 ring-slate-900 ring-offset-1" : ""
          }`}
        />
      ))}
      {allowNone && (
        <button
          type="button"
          title="No color"
          onClick={() => onChange(null)}
          className={`flex h-7 w-7 items-center justify-center rounded border border-slate-300 text-slate-400 ${
            value === null ? "ring-2 ring-slate-900 ring-offset-1" : ""
          }`}
        >
          <X size={14} />
        </button>
      )}
    </div>
  );
}
